module.exports = __webpack_public_path__ + "static/media/livedooh-dev-REST-API-2.afecdbac.svg";